import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: 1.5,
        textAlign: "center",
        px: 3,
      }}
    >
      <Typography sx={{ fontSize: "5rem", fontWeight: 800, color: "primary.main", lineHeight: 1 }}>
        404
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a1a" }}>
        Page not found
      </Typography>
      <Typography variant="body2" sx={{ color: "#666", maxWidth: 360 }}>
        The page you're looking for doesn't exist or may have been moved.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        disableElevation
        startIcon={<HomeRoundedIcon />}
        onClick={() => navigate("/")}
        sx={{ mt: 1.5, textTransform: "none", fontWeight: 700 }}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
}
